import React from 'react';
import { AutoComplete, Form, Select, message } from 'antd';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../store';
import TextFilter from '../../../components/TextFilter';
import { SelectEstadoService } from './services';
import type { IGetEstadosResponse } from './services';
import Swal from 'sweetalert2';
import mask from '../../../utils/mask';

interface ISelectEstadoProps {
  setCodEstado?: React.Dispatch<React.SetStateAction<number | undefined>>;
}

export const SelectEstado: React.FC<ISelectEstadoProps> = ({ setCodEstado }) => {
  const { Option } = AutoComplete;
  const parceiros = useSelector((state: ApplicationState) => state.auth.inscricaoAtiva);
  const [response, setResponse] = React.useState<IGetEstadosResponse | undefined>();

  function handleSelect(): void {
    if (parceiros.length === 0) {
      message.warning('Selecione um parceiro para ter acesso a lista de estados!');
      return;
    }

    if (localStorage.getItem(`responseEstadosFilter${window.location.pathname}`)) {
      const estados = JSON.parse(
        localStorage.getItem(`responseEstadosFilter${window.location.pathname}`) || '{}'
      );
      setResponse(estados);
      return;
    }

    try {
      SelectEstadoService.getEstados().then((response) => {
        setResponse(response.data);
        localStorage.setItem(
          `responseEstadosFilter${window.location.pathname}`,
          JSON.stringify(response.data)
        );
      });
    } catch (error) {
      Swal.fire({
        title: 'Não foi possivel carregar a lista de estados, por favor tente novamente!',
        html: '',
        icon: 'warning',
        showConfirmButton: false,
      });
    }
  }

  return (
    <Form.Item label={<TextFilter>Estado</TextFilter>} name="codEstado">
      <Select
        onFocus={handleSelect}
        data-testid="select"
        placeholder="Selecione o estado"
        onChange={(value) => {
          setCodEstado && setCodEstado(Number(value));
        }}
      >
        {response ? (
          response?.estados
            ?.sort(function (a, b) {
              var textA = a.uf.toUpperCase();
              var textB = b.uf.toUpperCase();
              return textA < textB ? -1 : textA > textB ? 1 : 0;
            })
            ?.map((item) => (
              <Option data-testid="select-option" key={item.codUf} value={item.codUf}>
                {mask('camelCase', item?.descricao) + ' - ' + item.uf}
              </Option>
            ))
        ) : (
          <Option value={-1}>Carregando...</Option>
        )}
      </Select>
    </Form.Item>
  );
};
